var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionContainer, SectionTitle } from '../styles';
import { TitleSection, Cards, Card, ThumbnailContainer } from './styles';
export var Links = function (_a) {
    var section = _a.section;
    var items = section.items, pageTitle = section.pageTitle;
    return items.length ? (_jsxs(SectionContainer, { children: [pageTitle && (_jsx(TitleSection, { children: _jsx(SectionTitle, { children: pageTitle }, void 0) }, void 0)), _jsx(Cards, { children: items.map(function (_a) {
                    var id = _a.id, title = _a.title, link = _a.link, thumbnailType = _a.thumbnailType, emoji = _a.emoji, image = _a.image;
                    return (_jsx("a", __assign({ href: link, target: "_blank", rel: "noreferrer" }, { children: _jsxs(Card, { children: [_jsx("div", { children: _jsx("h6", { children: title }, void 0) }, void 0), _jsxs(ThumbnailContainer, __assign({ "$type": thumbnailType, "$present": !!emoji || !!image }, { children: [thumbnailType === 'EMOJI' && emoji, thumbnailType === 'IMAGE' && image && (_jsx("img", { src: image }, void 0))] }), void 0)] }, id) }), id));
                }) }, void 0)] }, void 0)) : null;
};
